// removed by extract-text-webpack-plugin
module.exports = {"entityRegionTable":"region-entity-table-module__entityRegionTable___hEKzZ","numberCell":"region-entity-table-module__numberCell___2w6xD","cellInfoText":"region-entity-table-module__cellInfoText___20Rxe","tableInfoText":"region-entity-table-module__tableInfoText___leeDR","tableHeaderText":"region-entity-table-module__tableHeaderText___YAEoX","headerCellSubscript":"region-entity-table-module__headerCellSubscript___uGwJS","institutionType":"region-entity-table-module__institutionType___2SlVc","regularTableRow":"region-entity-table-module__regularTableRow___30dk8"};


//////////////////
// WEBPACK FOOTER
// ./src/components/region-entity-table/region-entity-table.module.scss
// module id = 73
// module chunks = 0 1